
<template>
    <div class="heads noSel">
		<div class="headerWrap">
			<div class="left">
				<!-- <div class="iconLeft" @click="goBack()">
					<img src="../../assets/images/left.png" alt="">
				</div> -->
				<div class="site">{{siteName}}</div>
			</div>
			<div class="navWrap">
				<div class="li" @click="popHide('AccountInfo')">
					<div class="icon" >
						<img :src="AccountInfo?navLi[0].icon2:navLi[0].icon1" alt="">
					</div>
					<div class="name">案例素材</div>
					<!-- <div class="navOpList">
						<div class="opList">
							<ul>
								<div class="iconsj"></div>
								<li class="avt"  @click="popHide(0)">
									<span>账号资料</span>
								</li>
								<li @click="popHide(1)">
									<span>法人身份证</span>
								</li>
								<li @click="popHide(2)">
									<span>营业执照</span>
								</li>
							</ul>
						</div>
					</div> -->
				</div>
				<div class="li" @click="popHide('video')">
					<div class="icon">
						<img :src="isVideo?navLi[3].icon2:navLi[3].icon1" alt="">
					</div>
					<div class="name">视频课程</div>
				</div>
				<div class="li" @click="navTwo()" v-if="knowledgePop" >
					<div class="icon">
						<img :src="isChisShow?navLi[1].icon2:navLi[1].icon1" alt="">
					</div>
					<div class="name">知识点</div>
				</div>
				<div class="li" @click="navTherr()" v-if="helpPop">
					<div class="icon">
						<img :src="isHelpShow?navLi[2].icon2:navLi[2].icon1" alt="">
					</div>
					<div class="name">需要帮助</div>
				</div>
				<div class="pageBtn leftBtn " :class="{noAvt:stepNum==0}" @click="popHide('leftBtn')">上一页</div>
				<div class="score magger" @click="popHide('leasing')"  :class="{avtScore:isLeasing}"  >
					<span class="de">{{regPage[stepNum].name}}</span><span class="icon"><img src="../../assets/images/site/down.png" alt=""></span>
					<div class="listPop" v-if="isLeasing" >
						<div class="iconsj"></div>
						<ul>
							<li v-for="(item,index) in regPage"  :key="index" :class="{avt:index==regIndex,colorFont:item.stateOne==1}" @click.stop="goReg(index)" v-show="item.name!='上传完成'" >
								{{item.name}}
								<div class="mark" :class="{colorOne:item.mark==item.maxMark&&item.stateOne==1,colorTwo:item.mark!=item.maxMark&&item.stateOne==1}">
									{{item.mark}}/{{item.maxMark}}
								</div>
								<div class="lists" v-if="item.markList" @click.stop="nofun()">
									<div class="iconsj"></div>
									<div class="ul">
										<div class="li" v-for="(item,indexs) in item.markList"  :key="indexs">
											{{item.name}}
											<div class="mark" :class="{colorOne:item.mark==item.maxMark,colorTwo:item.mark!=item.maxMark}">
												{{item.mark}}/{{item.maxMark}}
											</div>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="pageBtn" :class="{noAvt:stepNum==regPage.length-1}" @click="popHide('rightBtn')">下一页</div>
				<!-- <div class="li" @click="popHide('pingyin')">
					<div class="icon">
						<img :src="isPy?navLi[3].icon2:navLi[3].icon1" alt="">
					</div>
					<div class="name">拼音工具</div>
				</div> -->
			</div>
			<div class="headRingt">
				
				<div class="score" @click="score()" :class="{avtScore:isShowScore}"   v-if="stepNum==8">
					<span class="le">总评分</span>
					<span class="de">{{thisScore}}/{{numScore}}</span>
				</div>
				<div class="score" v-else style="background: #ffffff;">
				</div>
				<!-- <div class="more" @click="isHole=true">
					<img src="../../assets/images/more.svg"> <span>帮助&nbsp;></span>
				</div> -->
				<div class="headTx" v-if="user.username"  @click="isUse=!isUse">
					<img src="../../assets/images/avatar.png" alt="">
					<div class="opList" v-if="isUse">
						<ul>
							<div class="iconsj"></div>
							<li class="avt">
								<span>设置</span>
							</li>
							<li v-if="user.zs==9">
								<span>卖家1号</span>
							</li>
							<li @click.stop="outLogin">
								<span>退出登录</span>
							</li>
						</ul>
					</div>
				</div>
				<div class="ul"  v-else>
					<div class="li login" @click="isLogin=true">登录</div>
					<div class="li reg" @click="isReg=true">注册</div>
				</div>
			
			</div>
		</div>
		<!-- 背景 -->
		<div class="pop_bg"  v-if="isLogin"></div>
		<!-- 登陆弹出 -->
		<div class="loginPop"  id="loginWrap" v-if="isLogin" >
			<div class="popWrap">
				<div class="icon"  @click="colPop">
					<img src="../../assets/images/close.svg" >
				</div>
				<div class="popTab" id="login">
					<ul class="clear-fix">
						<li :class="{avt:loginIndex==0}" @click="loginIndex=0">
							<a>微信登陆</a>
						</li>
						<li :class="{avt:loginIndex==1}" @click="loginIndex=1">
							<a>账号登陆</a>
						</li>
					</ul>
				</div>
				<div class="popTab" id="bindLogin" style="display: none;">
					<ul class="clear-fix">
						<li style="width: 100% !important;">
							<a>绑定微信</a>
						</li>
					</ul>
				</div>
				<div class="popBox semllLonin" style="display: none;" >
					<div class="popCode">
						<img src="../../assets/images/code.png" >
					</div>
					<div class="tips">
						<p>请使用微信扫码二维码登陆</p>
					</div>
				</div>
				<div class="popBox phoneLogin">
					<div class="popTs">
						<img src="../../assets/images/res.png" >
					</div>
					<form class="layui-form">
						<div class="layui-input-inline">
							<input type="text" name="account" id="phone" placeholder="请输入手机号" class="layui-input" v-model="loginList.username">
						</div>
						<div class="layui-input-inline paswordPop">
							<input type="password" name="password" id="password" placeholder="请输入密码"  class="layui-input" v-model="loginList.password">
							<span class="noPwd" @click="commonShow(0)">忘记密码</span>
						</div>
						<div class="layui-input-inline login-btn">
							<div  class="layui-btn" id="loginBtn" @click="login">登录</div>
							<div class="popError clear-fix loginErr" style="display: none;">
								<span></span>
								<div class="err">
									<img src="../../assets/images/err.svg"/>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div class="linkPop phoneLogin" >
					<a href="javascript:void(0);" class="goRegister" @click="goReg">注册</a>
				</div>
				<div class="linkPop"  style="display: none;" >
					<a href="javascript:void(0);">登录</a>
				</div>
			</div>
		</div>
		<!-- 注册 -->
		<div class="pop_bg" v-if="isReg" ></div>
		<div class="loginPop" id="loginopt" v-if="isReg">
			<div class="popWrap">
				<div class="icon" @click="colPop">
					<img src="../../assets/images/close.svg" >
				</div>
				<div class="popTab">
					<ul class="clear-fix">
						<li style="width: 100% !important;">
							<a href="javascript:void(0);" id="phoneTitle">新用户注册</a>
						</li>
					</ul>
				</div>
				<div class="popBox">
					<div class="popTs">
						<img src="../../assets/images/res.png" >
					</div>
					<form class="layui-form">
						<div class="layui-input-inline" id="iptPhone">
							<input type="text" name="phone" id="mobile"  placeholder="请输入手机号" class="layui-input" v-model="regList.phone">
						</div>
						<div class="layui-input-inline" id="iptPhone">
							<input type="password" name="password" id="password"  placeholder="请输入密码" class="layui-input" v-model="regList.password">
						</div>
						<!-- <div class="layui-input-inline" id="bindPhone" style="display: none;">
							<p>您的手机号为：<span>136****3010</span></p>
						</div> -->
						<div class="layui-input-inline">
							<input  class="codes layui-input" id="code" type="text" name="code" placeholder="验证码" v-model="regList.validateCode" >
							<input type="button" class="btnCode icons" :disabled="isDisabled" :class="{ isCode: isDisabled }"  v-model="codeCont" @click="scenCode(0)">
						</div>
						<div class="layui-input-inline login-btn">
							<div  id="phoneBtns" class="layui-btn" @click="reg">下一步</div>
							<div class="popError clear-fix loginErr" style="display: none;">
								<span></span>
								<div class="err">
									<img src="../../assets/images/err.svg"/>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div class="linkPop goLogin" >
					<a href="javascript:void(0);" @click="isLogin=true;isReg=false">返回登录</a>
				</div>
			</div>
		</div>

		<!-- 手机验证 -->
		<div class="pop_bg" v-if="isCommom"></div>
		<div class="loginPop" id="loginopt" v-if="isCommom" >
			<div class="popWrap">
				<div class="icon" @click="isCommom=false">
					<img src="../../assets/images/close.svg">
				</div>
				<div class="popTab">
					<ul class="clear-fix">
						<li style="width: 100% !important;">
							<a href="javascript:void(0);" id="phoneTitle">{{commonTitle}}</a>
						</li>
					</ul>
				</div>
				<div class="popBox">
					<div class="popTs">
						<img src="../../assets/images/res.png">
					</div>
					<form class="layui-form">
						<div class="layui-input-inline" id="iptPhone">
							<input type="text" name="phone" id="mobile" placeholder="请输入手机号" class="layui-input" v-model="commonList.phone">
						</div>
						<div class="layui-input-inline" id="bindPhone" style="display: none;">
							<p>您的手机号为：<span>136****3010</span></p>
						</div>
						<div class="layui-input-inline">
							<input class="codes layui-input" id="code" type="text" name="code" placeholder="验证码" v-model="commonList.validateCode">
							<input type="button" class="btnCode icons" :disabled="isDisabled" :class="{ isCode: isDisabled }" v-model="codeCont"  @click="scenCode(1)">
						</div>
						<div class="layui-input-inline login-btn">
							<div class="layui-btn" @click="commonFun">下一步</div>
							<div class="popError clear-fix loginErr" style="display: none;">
								<span></span>
								<div class="err">
									<img src="../../assets/images/err.svg"/>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div class="linkPop goLogin">
					<a href="javascript:void(0);" @click="isLogin=true;isCommom=false">返回登录</a>
				</div>
			</div>
		</div>	

		<!-- 设置密码 -->
		<div class="pop_bg" v-if="isSetPwd"></div>
		<div class="loginPop" id="setPwdWrap"  v-if="isSetPwd">
			<div class="popWrap">
				<div class="icon" @click="isSetPwd=false">
					<img src="../../assets/images/close.svg">
				</div>
				<div class="popTab">
					<ul class="clear-fix">
						<li style="width: 100% !important;">
							<a href="javascript:void(0);">设置密码</a>
						</li>
					</ul>
				</div>
				<div class="popBox">
					<div class="popTs">
						<img src="../../assets/images/res.png">
					</div>
					<form class="layui-form">
						<div class="layui-input-inline">
							<input type="text" id="setPwd" placeholder="请设置密码,不少于6位数" class="layui-input" v-model="setPwdList.password">
						</div>
						<div class="layui-input-inline login-btn">
							<div  class="layui-btn"  @click="setFun()">完成</div>
							<div class="popError clear-fix loginErr" style="display: none;">
								<span></span>
								<div class="err">
									<img src="../../assets/images/err.svg"/>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div class="linkPop goLogin">
					<a href="javascript:void(0);"  @click="isLogin=true;isSetPwd=false">返回登录</a>
				</div>
			</div>
		</div>
		<div class="holePop" v-if="isHole">
			<div class="headTi">
				联系我们
				<div class="icon" @click="isHole=false" >
					<img src="../../assets/images/close.svg">
				</div>
			</div>
			<div class="lex">系统咨询QQ群</div>
			<div class="code">
				<img src="../../assets/images/codeSp.png" alt="">
			</div>
			<div class="ft">
				<div class="leq">
					QQ群名：跨境零距离
				</div>
				<div class="des">
					QQ群号：1003134481
				</div>
				<div class="dexs" @click="isFeedbac=true;isHole=false">
					意见反馈
				</div>
			</div>
		</div>
		<div class="pop_bg" v-if="isFeedbac"></div>
		<div class="feedbackPop" v-if="isFeedbac">
			<div class="feedbac">
				<div class="icon" @click="isFeedbac=false" >
					<img src="../../assets/images/close.svg">
				</div>
				<div class="title">意见反馈</div>
				<div class="textCont">
					<div class="name">*问题描述：</div>
					<div class="tex">
						<textarea v-model="feedbackLi.content" placeholder="请输入问题描述" name="" id="" cols="30" rows="10"></textarea>
					</div>
				</div>
				<!-- <div class="textCont">
					<div class="name">上传图片：</div>
					<div class="tex upload">
						<el-upload
						class="upload-demo"
						 accept=".jpg, .png"
						action = "http://120.78.89.173:8080/SysApi/sys/oss/upload"
						:on-preview="handlePreview"
						:on-remove="handleRemove"
						:limit='4'
						list-type="picture">
						<div class="odPik">
							+
						</div>
						</el-upload>
						<div class="odPik" v-for="(item,index) in fileList" :key="index"><img :src="item.url" alt=""></div>
						<div class="dev">文件必须小于 10MB，接受的格式为 *.png、*.jpg，最多上传四张</div>
					</div>
				</div> -->
				<div class="textCont">
					<div class="name">联系方式：</div>
					<div class="tex">
						<input v-model="feedbackLi.contract" type="text" placeholder="请输入邮件、手机号码或QQ号码任意一种联系方式">
					</div>
				</div>
				<div class="sBtn" @click="feedbackSave">提交反馈</div>
			</div>
		</div>
    </div>
</template>
<script>
// import qs from 'qs'
export default {
  name: "heads",
   data: function() {
    return {
		isFeedbac:false,
		fileList: [],
		feedbackLi:{
			contract:'',
			content:'',
		},
		loginIndex:1,
		rlen:history.length,
		isTwo:false,
		isTherr:false,
		iszl:false,
		navIndex:0,
		navLi:[{
			icon1:require("../../assets/images/site/li_ci2.png"),
			icon2:require("../../assets/images/site/li_cis2.png"),
		},
		{
			icon1:require("../../assets/images/site/li_ci3.png"),
			icon2:require("../../assets/images/site/li_cis3.png"),
		},
		{
			icon1:require("../../assets/images/site/li_ci1.png"),
			icon2:require("../../assets/images/site/li_cis1.png"),
		},
		{
			icon1:require("../../assets/images/site/videoImg.png"),
			icon2:require("../../assets/images/site/videoImg.png"),
		},
		],
		isHole:false,
		isUse:false,
		isSetPwd:false,
		isCommom:false,
		isLogin:false,
		regIndex:null,
		isDisabled:false,
		isReg:false,
		regList:{
			phone:'',
			validateCode:'',
			uuid:'',
			password:''
		},
		loginList:{
			username:'',
			password:''
		},
		commonList:{
			phone:'',
			validateCode:'',
			uuid:''
		},
		setPwdList:{
			password:'',
			uuid:''
		},
		commonTitle:'',
		commIndex:null,
		outTime:null,
		codeCont:'获取验证码',
		countdown:60
    };
  },
  props: ["stepNum",'AccountInfo','siteName','cancalChild','helpPop','knowledgePop','isShowScore','isChisShow','isHelpShow','numScore','thisScore','isVideo','isLeasing','goRegPage','regPage'],
  components: {
  },
   computed: {
    user() {
      return this.$store.getters.user;
	}
  },
  created(){
	  this.getInfo()
  },
  mounted () {
    /* eslint-disable */
    },
   methods: {
	   nofun(){
	   },
	   feedbackSave(){
		if(!this.feedbackLi.content){
			this.$message({
			message: "请输入问题描述",
			duration: 1000,
			type:'error'
			});
			return
		}
		if(!this.feedbackLi.contract){
			this.$message({
			message: "请输入邮件、手机号码或QQ号码任意一种联系方式",
			duration: 1000,
			type:'error'
			});
			return
		}
		// this.isFeedbac=false;
		// this.$message({
		// 	message: "反馈成功",
		// 	duration: 1000,
		// 	type:'success'
		// 	});
			//   this.feedbackLi.content=''
			// this.feedbackLi.contract=''
		this.$axios
          .post(this.interfaceJson.serverAddress+"/api/feedback/add", this.feedbackLi)
          .then(res => {
          let data=res.data;
          if(data.code==0){
			this.isFeedbac=false;
			this.$message({
				message: "反馈成功",
				duration: 1000,
				type:'success'
			  });
			  this.feedbackLi.content=''
			this.feedbackLi.contract=''
          }
          });
	},
	handleRemove(file, fileList) {
	console.log(file, fileList);
	},
	handlePreview(file) {
	console.log(file);
	},
	goReg(e){
		this.goRegPage(e)
		this.regIndex=e
		this.popHide("isLeasing")
	},
	score(){
		this.popHide('score')
	},
	goBack () {
		sessionStorage.clear()
        let len = this.rlen - history.length - 1;//-1是不进入iframe页面的下级页面直接退出的话，执行后退一步的操作
        this.$router.go(len);
    },

	navTwo(){
		this.popHide('chis')
	},
	navTherr(){
		this.popHide('help')
	},
	popHide(e){
	  this.cancalChild(e);
    },
	outLogin(){
		localStorage.clear();
		sessionStorage.clear();
		this.$store.dispatch("clearCurrentState");
		this.isUse=false;
		this.goLinks('/')
	}, 
	colPop(){
		this.isLogin=false;
		this.isReg=false;
	},
  },
  
};
</script>
<style lang="scss" scoped>
	.listPop{
		position: absolute;
		width:227px;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 20px rgba(0,0,0,0.16);
		opacity:1;
		border-radius:2px;
		right: -42px;
		top: 69px;
		.iconsj{
			transform:rotate(180deg);
			position: absolute;
			width: 0;
			height: 0;
			border-width:10px;
			border-style: solid;
			border-color:  #fff  transparent transparent transparent;
			top: -20px;
    		right: 105px;

		}
		ul{
			height: 369px;
 			// overflow-x: auto;
			li{
				width:227px;
				height:41px;
				line-height: 41px;
				box-sizing: border-box;
				border-bottom:1px solid #EEEEEE;
				text-align: left;
				cursor: pointer;
				padding-left: 23px;
				color: #57616C;
				font-size: 12px;
				padding-right: 51px;
				position: relative;
				.mark{
					position: absolute;
    				left: 176px;
					top: 0;
				}
				.colorOne{
					color: #158437;
				}
				.colorTwo{
					color: #FF0000;
				}
				.thrr{
					color: #57616C;
				}
				.lists{
					width:227px;
					position: absolute;
					right: -250px;
					display: none;
					top: 0;
					background:rgba(255,255,255,1);
					box-shadow:0px 0px 20px rgba(0,0,0,0.16);
					opacity:1;
					border-radius:2px;
					.iconsj{
						transform:rotate(90deg);
						top: 5px;
						right: 226px;
					}
					.ul{
						max-height: 369px;
 						overflow-x: auto;
						 .li{
							 width:227px;
							height:41px;
							line-height: 41px;
							box-sizing: border-box;
							border-bottom:1px solid #EEEEEE;
							text-align: left;
							cursor: auto;
							padding-left: 23px;
							color: #57616C;
							font-size: 12px;
							padding-right: 51px;
							position: relative;
							margin-left: 0;
							
						 }
					}
				}
			}
			.colorFont{
				color: #999999;
			}
			li:hover{
				background-color: #F3CD70;
			}
			li:hover .lists{
				display: block;
			}
			
			// .avt{
			// 	background-color: #F3CD70;
			// }
		}
	}
    .headerWrap .left{
		display: flex;
	}
	.headerWrap .site{
		line-height: 80px;
		font-size:14px;
		margin-left: 20px;
	}
	.iconLeft{
		color: #2F3A48;
		background-color: #F3CD70;
		width:30px;
		line-height: 80px;
		text-align: center;
		cursor: pointer;
	}
	.iconLeft img{
		width: 20px;
		height: 20px;
		vertical-align: middle;
		margin-top: -3px;
	}
		.holePop{
		position: fixed;
		background-color: #FFFFFF;
		left: 50%;
		top: 50%;
		z-index: 99;
		width: 400px;
		height: 362px;
		transform: translate(-50%, -50%);    /* 50%为自身尺寸的一半 */
		box-shadow:0px 0px 20px rgba(0,0,0,0.16);
		border-radius:2px;
		box-sizing: border-box;
		padding: 0 24px;
		text-align: center;
	}
	.headTi{
		position: relative;
		border-bottom:1px solid #E8E8E8;
		height: 40px;
		line-height: 43px;
		font-size: 12px;
		text-align: left;
	}
	.holePop .lex{
		line-height:17px;
		font-size: 12px;
		margin-top: 30px;
	}
	.holePop .code {
		margin-top: 20px;
	}
	.holePop .code img{
		width: 120px;
		height: 120px;
	}
	.holePop .ft{
		border-top: 1px dashed #E8E8E8;
		margin-top: 25px;
	}
	.holePop .ft .leq{
		margin-top: 16px;
		font-size: 12px;
	}
	.holePop .ft .des{
		margin-top: 5px;
		font-size: 12px;
	}
	.holePop .ft .dexs{
		color: #178AFF;
		margin-top: 12px;
		font-size: 12px;
		cursor: pointer;
	}
	.feedbackPop{
		position: fixed;
		background-color:#FAFAFA;
		left: 50%;
		top: 50%;
		z-index: 99;
		width: 450px;
		transform: translate(-50%, -50%);
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
		border-radius: 2px;
		box-sizing: border-box;
		padding: 0 26px 64px 26px;
		// text-align: center;
		.feedbac{
			position: relative;
			.icon{
				position: absolute;
				right: 0;
				top: 12px;
				cursor: pointer;
				img{
					width: 10px;
					height: 10px;
				}
			}
		}
		.sBtn{
			position: absolute;
			width:78px;
			height:30px;
			background:rgba(23,138,255,1);
			opacity:1;
			font-size:12px;
			color: #fff;
			line-height: 30px;
			text-align: center;
			border-radius:6px;
			right: 0;
			bottom: -52px;
			cursor: pointer;
		}
		.title{
			padding-top: 24px;
			margin-bottom: 17px;
			font-size:12px;
		}
		.textCont{
			display: flex;
			margin-bottom: 10px;
			.name{
				width: 66px;
				font-size:12px;
				line-height: 30px;
				height:30px;
			}
			.tex{
				flex: 1;
				textarea{
					height:122px;
					width: 100%;
					resize: none;
					outline: none;
					background:rgba(255,255,255,1);
					border:1px solid rgba(225,225,226,1);
					opacity:1;
					border-radius:4px;
					box-sizing: border-box;
					font-size: 12px;
					padding: 10px;
				}
				.odPik{
					width:47px;
					height:47px;
					background:rgba(255,255,255,1);
					border:1px solid rgba(225,225,226,1);
					opacity:1;
					border-radius:2px;
					text-align: center;
					color: #E8E8E8;
					font-size: 18px;
					line-height: 47px;
					cursor: pointer;
				}
				.dev{
					height:14px;
					font-size:10px;
					font-family:PingFang SC;
					font-weight:400;
					line-height:14px;
					color:rgba(146,145,147,1);
					opacity:1;
					padding-top: 4px;
				}
				input{
					height:30px;
					background:rgba(255,255,255,1);
					border:1px solid rgba(225,225,226,1);
					box-sizing: border-box;
					opacity:1;
					width: 100%;
					padding: 7px;
					border-radius:4px;
					font-size: 12px;
					outline: none;
				}
			}
			.upload{
				display: flex;
				flex-wrap:wrap ;
			}
		}
	}
	.headTi .icon{
		position: absolute;
		right: 0;
		top: 15px;
		width: 12px;
		height: 12px;
		cursor: pointer;
	}
	.headTi .icon img{
		width: 12px;
		vertical-align: top;
		height: 12px;
	}
	.headerWrap{
		background-color: #FFFFFF;
		height:80px;
		box-shadow:0px 3px 20px rgba(0,0,0,0.1);
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: relative;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;
		width: 100%;
	}
	.navWrap{
		display: flex;
		// position: absolute; 
		align-items: center;
		// left: 50%;
		// top: 50%;
		// transform: translate(-50%, -50%);
		.pageBtn{
			width: 120px;
			height: 40px;
			border: 1px solid #57616C;
			opacity: 1;
			line-height: 40px;
			border-radius: 4px;
			color: #57616C;
			font-size: 12px;
			text-align: center;
			cursor: pointer;
		}
		.leftBtn{
			margin-left: 116px;
		}
		.noAvt{
			color: #E8E8E8;
			border: 1px solid #E8E8E8;
		}
		
	}
	.navWrap .li{
		margin-left: 30px;
		font-size: 14px;
		height: 80px;
		cursor: pointer;
		position: relative;
		}
	
	
	.navWrap .li .icon{
		margin-top: 26px;
		text-align: center;
		line-height: 20px;
		}
	.navWrap .li .icon img{
		width: 16px;
		vertical-align: middle;
	}	
	.navWrap .li .name{
		margin-top: 11px;
		font-size: 12px;
		color: #57616C;
	}		
	.navWrap .li:first-of-type{
		margin-left: 0;
	}
	.navWrap .avt .name{
		color: #000000;
		position: relative;
	}
	.navOpList{
		width:0;
		height: 0;
		position: relative;
	}	
	.navOpList .opList{
		top: 11px;
		right: auto;
		left: -52px !important;
		width: 180px;
		display: none;
	}
	// .navWrap .li:hover .navOpList .opList{
	// 		display: block;	
	// }
	.navOpList .opList .iconsj{
		right: 82px;
	}
	.navOpList .opList ul li{
		text-align: left;
		padding-left: 30px;
		box-sizing: border-box;
		width: 180px;
	}
	.navWrap .score{
		cursor: pointer;
		width:160px;
		height:40px;
		border:1px solid #F3CD70;
		border-radius:20px;
		line-height: 40px;
		box-sizing: border-box;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		margin:0 20px;
	}
	.navWrap .score .le{
		font-size:12px;
		color: #57616C;
		vertical-align: middle;
	}
	.navWrap .score .de{
		font-size:20px;
		color: #57616C;
		margin-left: 9px;
		vertical-align: middle;
		cursor: pointer;
	}
	.navWrap .avtScore{
		background-color: #F3CD70;
	}
	.navWrap .magger{
		position: relative;
	}
	.navWrap .magger .de{
		font-size: 12px;
		display: inline-block;
		width: 70px;
		overflow: hidden;
		height: 40px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.navWrap .magger .icon{
		width: 10px;
		height: 6px;
		margin-left: 21px;
		img{
			width: 100%;
			height: 100%;
			vertical-align: top;
		}
	}
	.headRingt{
		display: flex;
		align-items: center;
		margin-right: 24px;
		.score{
			width: 110px;
			height: 32px;
			cursor: pointer;
			background: #F3CD70;
			opacity: 1;
			text-align: center;
			border-radius: 4px;
			line-height: 32px;
			font-size: 14px;
			color: #232F3E;
			.le{
				font-size: 14px;
				color: #232F3E;
			}
			.de{
				font-size: 14px;
				color: #232F3E;
			}
		}
	}
	.headRingt .more{
		display: flex;
		cursor: pointer;
	}
	.headRingt .more img{
		width:14px;
		height:14px;
	}
	.headRingt .more span{
		font-size:12px;
		height: 14px;
		line-height: 14px;
		margin-left: 9px;
	}
	.headRingt .ul{
		display: flex;
		margin-left: 40px;
	}
	.headRingt .ul .li{
		width:80px;
		height:40px;
		background-color: #F3CD70;
		border-radius:21px;
		line-height: 40px;
		text-align: center;
		font-size: 14px;
		cursor: pointer;
		color: #232F3E;
	}
	.headRingt .ul .reg{
		background-color: #ffffff;
		box-sizing: border-box;
		border:1px solid #E1E1E2;
		margin-left: 10px;
	}
	.headTx{
		width: 40px;
		height: 40px;
		background-color: #F3CD70;
		border-radius:50% ;
		margin-left: 40px;
		cursor: pointer;
		position: relative;
	}
	.headTx img{
		width: 100%;
	}
	.isCode{
		background-color:#cccccc !important;
	}
	.layui-btn{
		text-align: center;
	}

.pop_bg{
	width: 100%;
    left: 0px;
    top: 0px;
    height: 100%;
    position: fixed;
/*    user-select: none; */
    z-index: 99;
	background-color: #000;
    opacity: .5;
}
.tsPop{
	position: fixed;
	background-color: #CF5D4F;
	position: absolute; 
	left: 50%;
	top: 50%;
	 z-index: 9999999;
	transform: translate(-50%, -50%);    /* 50%为自身尺寸的一半 */
	border-radius: 5px;
	width: 260px;
	height: 60px;
	color: #FFF;
	font-size: 14px;
	line-height: 60px;
	text-align: center;
}
.loginPop{
	position: fixed;
	background-color: #FFFFFF;
    position: absolute; 
	left: 50%;
	top: 50%;
	 z-index: 9999999;
    transform: translate(-50%, -50%);    /* 50%为自身尺寸的一半 */
	border-radius: 5px;
	
}
.popWrap{
	box-sizing: border-box;
	position: relative;
	padding: 14px 45px 0;
	width: 350px;
	height: 480px;
}
.popTab{
	border-bottom: 1px solid #E1E1E2;
}
.popTab ul li{
	 float: left;
	 padding: 12px 0;
	 width: 50%;
	 text-align: center;
	 height: 12px;
    line-height: 12px;
}
.popTab ul li a{
	font-size: 12px;
	color: #929193;
	position: relative;
}
.popTab ul .avt a{
	color:#178aff;
}
.popTab ul .avt a:after{
	content: '';
	position: absolute;
	background-color: #178AFF;
	height: 2px;
	width: 100%;
	bottom:-9px;
	left: 0;
	}
.popCode{
	border: 1px solid #e1e1e2;
	width: 260px;
	height: 260px;
	box-sizing: border-box;
	padding: 15px 11px 13px 14px;
	margin-top: 46px;
}	
.popCode img{
	width: 235px;
	height: 232px;
}
.popTs{
	margin-top: 38px;
	text-align: center;
}
.popBox .layui-form{
	margin-top: 32px;
}
.popBox .login-btn{
	padding-top: 20px;
}
.popBox .layui-btn{
	width: 100%;
	background-color: #178AFF;
}
.popBox .layui-input-inline{
	width: 100%;
	margin-bottom: 10px;
	position: relative;
}
.popBox .paswordPop{
	position: relative;
}
.popBox .paswordPop .noPwd{
	position: absolute;
	right: 14px;
	font-size: 12px;
	height: 12px;
	line-height: 12px;
	color: #777777;
	top: 14px;
	cursor: pointer;
	z-index: 99;
}
.popBox .paswordPop input{
	padding-right: 100px;
}
.popBox .layui-input-inline input{
	border:1px solid #E1E1E2 ;
	padding-left: 16px;
}
.popBox .layui-input-inline button{
	height: 40px;
	line-height: 40px;
	border: 0;
	border-radius: 3px;
	color: #FFFFFF;
}
.popBox .layui-input-inline input,.popBox .layui-form .layui-btn {
	height: 40px;
	line-height: 40px;
	width: 100%;
    box-sizing: border-box;
	border-radius: 3px;
}
.popBox .layui-form .layui-btn{
	border: 0;
	color: #FFFFFF;
}
.popBox .layui-input-inline .codes,.popBox .layui-input-inline .btnCode{
	width: 125px;
	box-sizing: border-box;
}
.popBox .layui-input-inline .codes{
	border:1px solid #E1E1E2 ;
}
.loginPop .icon{
	position: absolute;
	right: 9px;
	top: 14px;
	cursor: pointer;
}
.loginPop .icon img{
	width: 10px;
	height: 10px;
}
.popBox .layui-input-inline .btnCode{
	margin-left: 10px;
	background-color: #178AFF;
	color: #fff;
	border: 0;
	height: 40px;
	line-height: 40px;
	cursor: pointer;
	border-radius:5px ;
	padding-left: 0 !important;
}
.popWrap .linkPop{
	position: absolute;
	bottom: 30px;
	text-align: center;
	width: 100%;
	height: 14px;
	line-height: 14px;
	left: 0;
}
 .linkPop a{
	color: #333333;
	font-size: 14px;
	cursor: pointer;
 }
.tips{
	margin-top: 21px;
}
.tips p{
	font-size: 14px;
	color: #333333;
	text-align: center;
}
.popError{
	position: absolute;
	right: 0;
	top: -1px;
}
.popError .err{
	width: 12px;
    border: 1px solid #cf5d4f;
    height: 12px;
    text-align: center;
    box-sizing: border-box;
    line-height: 7px;
    border-radius: 50%;
	float: right;
}
.popError span{
	float: right;
	color: #cf5d4f;
	font-size: 12px;
	margin-left: 7px;
	line-height: 12px;
}

.popError .err img{
	width: 7px;
}
.popBox .upPhone .layui-btn{
	background-color: #FFFFFF;
	box-sizing: border-box;
	border:1px solid #178AFF;
	color: #333333;
}
.opList{
	background-color: #ffffff;
	border-radius: 3px;
	width: 100px;
	position: absolute;
	right: -1px;
	top: 72px;
	z-index: 9999;
	box-shadow:0px 0px 20px rgba(0,0,0,0.16);
	border-radius: 2px;

}
.opList ul{
	position: relative;
}
.opList .iconsj{
	transform:rotate(180deg);
	position: absolute;
	width: 0;
	height: 0;
	border-width:10px;
	border-style: solid;
	border-color:  #fff  transparent transparent transparent;
	top: -20px;
    right: 11px;
}
.opList ul li{
	height: 40px;
	line-height: 40px;
	border-bottom: 1px solid #eeeeee;
	width: 100px;
	text-align: center;
	position: relative;
	cursor: pointer;
}
.opList ul li:last-of-type{
	border-bottom:0;
}
.opList ul li span{
	color: #333;
	font-size: 12px;
}
</style>
